import theme from "@/constants/theme";
import React from "react";

const styles: Record<string, React.CSSProperties> = {
  emotionsContainer: {
    flex: 1,
    marginBottom: 16,
  },
  emotionItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#0f1a3d",
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    minHeight: 100,
    border: "none",
    gap: 8,
  },
  emotionItemSelected: {
    backgroundColor: "#1c2e5f",
  },
  iconContainer: {
    marginRight: 12,
  },
  textContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
  },
  emotionLabel: {
    color: theme.colors.text.title,
    fontSize: 18,
    marginBottom: 4,
    textAlign: "left",
  },
  emotionLabelSelected: {
    color: "#fff",
  },
  emotionDescription: {
    color: theme.colors.text.caption,
    fontSize: 14,
    textAlign: "left",
  },
  emotionDescriptionSelected: {
    color: "#fff",
  },
};

export default styles;
